export const components = {
  projectContent: () => null,
}
